// // // =====================================================================
// // // COMPLETE FIXED ALERT WINDOW - With ₹ and % symbols
// // // =====================================================================
// // import React, { useState, useEffect, useRef } from "react";
// // import { FaRegFileAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";
// // import { FiX } from "react-icons/fi";
// // import { Button, Modal } from "react-bootstrap";
// // import { toast } from "react-toastify";
// // import { executeAlertDataService } from "../apiservice/executeAlertDataService";
// // import { fetchSymbolService } from "../apiservice/fetchSymbolService";
// // import { useAuth } from "../../context/auth";
// // import { sendGlobalWS } from "../../context/UseWebSocketContext";

// // const AlertWindow = ({ onClose, darkMode = false }) => {
// //   const { getSecKey, getLoginToken, getGoogleAuthToken } = useAuth();
// //   const token = getLoginToken() || getGoogleAuthToken();
  
// //   // ================= ALL STATES =================
// //   const [activeModal, setActiveModal] = useState(null);
// //   const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
// //   const [showRiskSettings, setShowRiskSettings] = useState(false);
// //   const [activeTab, setActiveTab] = useState("normal");
// //   const [isLoading, setIsLoading] = useState(false);
  
// //   // Form States
// //   const [symbol, setSymbol] = useState("");
// //   const [exchange, setExchange] = useState("NSE");
// //   const [contractType, setContractType] = useState("EQ");
// //   const [monthlyExpiry, setMonthlyExpiry] = useState(0);
// //   const [weeklyExpiry, setWeeklyExpiry] = useState(0);
// //   const [exactStrike, setExactStrike] = useState(0);
// //   const [duplicatePosition, setDuplicatePosition] = useState(false);
// //   const [expireInSecond, setExpireInSecond] = useState(0);
// //   const [existingClose, setExistingClose] = useState(false);
// //   const [action, setAction] = useState("BUY");
// //   const [quantityType, setQuantityType] = useState("normal");
// //   const [quantity, setQuantity] = useState("0");
// //   const [entryOrderType, setEntryOrderType] = useState("MARKET");
// //   const [price, setPrice] = useState(0);
// //   const [ifTouchPrice, setIfTouchPrice] = useState(0);
// //   const [tpType, setTpType] = useState("BY_POINTS");
// //   const [tpValue, setTpValue] = useState(0);
// //   const [slType, setSlType] = useState("BY_POINTS");
// //   const [slValue, setSlValue] = useState(0);
// //   const [slIfTouchPrice, setSlIfTouchPrice] = useState(0);
// //   const [breakevenType, setBreakevenType] = useState("BY_POINTS");
// //   const [breakeven, setBreakeven] = useState(0);
// //   const [slTrailType, setSlTrailType] = useState("BY_POINTS");
// //   const [slTrailValue, setSlTrailValue] = useState(0);
// //   const [slPriceMove, setSlPriceMove] = useState(0);
// //   const [showExpiry1, setShowExpiry1] = useState("month");
// //   const [list, setList] = useState({});
// //   const [listsCache, setListsCache] = useState({});

// //   // Refs for input auto-select
// //   const symbolInputRef = useRef(null);
// //   const quantityInputRef = useRef(null);
// //   const priceInputRef = useRef(null);
// //   const tpValueInputRef = useRef(null);
// //   const slValueInputRef = useRef(null);
// //   const breakevenInputRef = useRef(null);
// //   const slTrailValueInputRef = useRef(null);
// //   const slPriceMoveInputRef = useRef(null);
// //   const expireInputRef = useRef(null);
// //   const touchPriceInputRef = useRef(null);

// //   // Apply dark mode
// //   useEffect(() => {
// //     if (darkMode) {
// //       document.body.classList.add('dark-mode');
// //     } else {
// //       document.body.classList.remove('dark-mode');
// //     }
// //   }, [darkMode]);

// //   const handleClose = () => setActiveModal(null);

// //   // ================= AUTO-SELECT FUNCTION =================
// //   const handleInputFocus = (e) => {
// //     e.target.select();
// //   };

// //   // ================= FETCH SYMBOLS =================
// //   const keyMapping = {
// //     "BSE:Equity": "BSE_EQ", "BSE:Futures": "BSE_FUT", "BSE:Options": "BSE_OPT", "BSE:Call/Put": "BSE_OPT",
// //     "NSE:Equity": "NSE_EQ", "NSE:Futures": "NSE_FUT", "NSE:Options": "NSE_OPT", "NSE:Call/Put": "NSE_OPT",
// //   };

// //   useEffect(() => {
// //     if (exchange && contractType && token) {
// //       const rawKey = `${exchange}:${contractType}`;
// //       const key = keyMapping[rawKey] || rawKey;

// //       if (listsCache[key]) {
// //         setList(listsCache[key]);
// //         return;
// //       }

// //       const fetchSymbols = async () => {
// //         const payload = { exchange, contract_type: contractType };
// //         const result = await fetchSymbolService(token, payload);
// //         if (result.success) {
// //           const symbols = result.data?.data;
// //           const symbolDict = symbols.reduce((acc, item) => {
// //             acc[item] = item;
// //             return acc;
// //           }, {});
// //           setListsCache((prev) => ({ ...prev, [key]: symbolDict }));
// //           setList(symbolDict);
// //         } else {
// //           setList({});
// //         }
// //       };
// //       fetchSymbols();
// //     } else {
// //       setList({});
// //     }
// //   }, [exchange, contractType, token]);

// //   const handleChange1 = (e) => {
// //     const selectedSymbol = e.target.value.toUpperCase();
// //     setSymbol(selectedSymbol);
// //     console.log("📊 Symbol selected:", selectedSymbol);
// //   };

// //   // ================= API DATA =================
// //   const data = {
// //     symbol: symbol,
// //     exchange: exchange,
// //     contract_type: contractType,
// //     monthly_expiry: Number(monthlyExpiry),
// //     weekly_expiry: Number(weeklyExpiry),
// //     exact_strike: Number(exactStrike),
// //     expire_in_second: Number(expireInSecond),
// //     duplicate_position: duplicatePosition,
// //     action: action,
// //     quantity: action === "CLOSE" ? 1 : Number(quantity || 0),
// //     quantity_type: quantityType === "normal" ? "NORMAL" : quantityType === "by_risk_percentage" ? "BY_RISK_PERCENTAGE" : "BY_AMOUNT",
// //     entry_order_type: entryOrderType,
// //     price: Number(price),
// //     update_order_id: "",
// //     update_type: "",
// //     if_touch_price: Number(ifTouchPrice),
// //     tp_type: tpType?.toUpperCase() || "NORMAL",
// //     tp_value: Number(tpValue),
// //     sl_type: slType?.toUpperCase() || "NORMAL",
// //     sl_value: Number(slValue),
// //     sl_if_touch_price: Number(slIfTouchPrice),
// //     breakeven_type: breakevenType?.toUpperCase() || "NORMAL",
// //     breakeven: Number(breakeven),
// //     sl_trail_type: slTrailType,
// //     sl_trail_value: Number(slTrailValue),
// //     sl_price_move: Number(slPriceMove),
// //     existing_close: existingClose,
// //   };

// //   const generatAlertData = { ...data };
// //   const strategyJson = {
// //     ...data,
// //     action: "{{strategy.order.action}}",
// //     quantity: "{{strategy.order.contracts}}",
// //   };

// //   // ================= VALIDATION =================
// //   const validateExecute = (symbol = "", quantity = "") => {
// //     if (!symbol || symbol.trim() === "") {
// //       return "❌ Symbol is required!";
// //     }
// //     if (action !== "CLOSE" && (!quantity || Number(quantity) <= 0)) {
// //       return "❌ Quantity must be greater than 0!";
// //     }
// //     return null;
// //   };

// //   // ================= GET SECURITY KEY =================
// //   const getSecurityKey = () => {
// //     try {
// //       let key = getSecKey();
// //       if (key && key !== "undefined" && key !== "null" && key.length > 10) {
// //         return key;
// //       }
// //       key = localStorage.getItem('sec_key');
// //       if (key && key !== "undefined" && key !== "null" && key.length > 10) {
// //         return key;
// //       }
// //       key = localStorage.getItem('session-token');
// //       if (key && key.length > 10) {
// //         return key;
// //       }
// //       return null;
// //     } catch (error) {
// //       console.error("Error getting security key:", error);
// //       return null;
// //     }
// //   };

// //   // ================= FORMAT VALUE WITH SYMBOLS =================
// //   const getDisplayValue = () => {
// //     if (!quantity || quantity === "0") {
// //       if (quantityType === "by_risk_percentage") return "0%";
// //       if (quantityType === "by_amount") return "₹0";
// //       return "0";
// //     }
    
// //     if (quantityType === "by_risk_percentage") {
// //       return `${quantity}%`;
// //     } else if (quantityType === "by_amount") {
// //       return `₹${quantity}`;
// //     }
// //     return quantity;
// //   };

// //   const formatAmount = (value) => {
// //     if (!value || value === 0) return "₹0";
// //     return `₹${value}`;
// //   };

// //   const formatPercentage = (value) => {
// //     if (!value || value === 0) return "0%";
// //     return `${value}%`;
// //   };

// //   const handleNumberChange = (setter, e) => {
// //     const rawValue = e.target.value.replace(/[^\d.]/g, "");
// //     const parts = rawValue.split(".");
// //     if (parts.length > 2) return;
// //     setter(rawValue === "" ? 0 : Number(rawValue));
// //   };

// //   // ================= EXECUTE BUTTON =================
// //   const handleExecuteButton = async () => {
// //     const secKey = getSecurityKey();
    
// //     const validateError = validateExecute(symbol, quantity);
// //     if (validateError) {
// //       toast.warning(validateError);
// //       return;
// //     }

// //     if (!secKey) {
// //       toast.error("🔑 Security key not found! Please refresh.");
// //       return;
// //     }

// //     setIsLoading(true);
// //     try {
// //       const response = await executeAlertDataService(data, secKey);
// //       if (response.status === 200) {
// //         if (response?.data?.error === false) {
// //           toast.success(response?.data?.data || "Order executed successfully!");
// //           sendGlobalWS({ r: "orders" });
// //           sendGlobalWS({ r: "positions" });
// //           sendGlobalWS({ r: "alerts" });
// //         } else {
// //           toast.error(response?.data?.data || "Execution failed");
// //         }
// //       } else {
// //         toast.error(response?.data?.data || "Execution failed");
// //       }
// //     } catch (error) {
// //       console.error("Execute error:", error);
// //       toast.error(error?.response?.data?.data || "Something went wrong");
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   // ================= RESET FUNCTION =================
// //   const handleReset = () => {
// //     setSymbol("");
// //     setContractType("EQ");
// //     setExchange("NSE");
// //     setMonthlyExpiry(0);
// //     setWeeklyExpiry(0);
// //     setExactStrike(0);
// //     setDuplicatePosition(false);
// //     setExpireInSecond(0);
// //     setExistingClose(false);
// //     setQuantityType("normal");
// //     setQuantity("0");
// //     setEntryOrderType("MARKET");
// //     setPrice(0);
// //     setIfTouchPrice(0);
// //     setTpType("BY_POINTS");
// //     setTpValue(0);
// //     setSlType("BY_POINTS");
// //     setSlValue(0);
// //     setSlIfTouchPrice(0);
// //     setBreakevenType("BY_POINTS");
// //     setBreakeven(0);
// //     setSlTrailType("BY_POINTS");
// //     setSlTrailValue(0);
// //     setSlPriceMove(0);
// //     setShowExpiry1("month");
// //     setShowRiskSettings(false);
// //     setShowAdvancedSettings(false);
// //     toast.info("🔄 Form reset successfully!");
// //   };

// //   const handleCopyJSON = () => {
// //     const jsonString = activeTab === "strategy" 
// //       ? JSON.stringify(strategyJson, null, 2)
// //       : JSON.stringify(generatAlertData, null, 2);
// //     navigator.clipboard.writeText(jsonString);
// //     toast.success("📋 JSON copied!");
// //   };

// //   const handleCopyURL = () => {
// //     const secKey = getSecurityKey();
// //     if (secKey) {
// //       navigator.clipboard.writeText(`https://api.algocontroller.com/v2/sendAlert/${secKey}`);
// //       toast.success("🔗 Webhook URL copied!");
// //     } else {
// //       toast.error("Cannot copy URL: Security key not found!");
// //     }
// //   };

// //   const handleGenerateAlertModel = () => {
// //     if (!symbol || symbol.trim() === "" || quantity <= 0) {
// //       toast.warning("⚠️ Please select Symbol and Quantity");
// //     } else {
// //       setActiveModal("alert-model");
// //     }
// //   };

// //   // Risk and Advanced Settings toggles
// //   const handleRiskSetting = (e) => {
// //     e.preventDefault();
// //     setShowRiskSettings(!showRiskSettings);
// //   };

// //   const handleAdvanceSetting = (e) => {
// //     e.preventDefault();
// //     setShowAdvancedSettings(!showAdvancedSettings);
// //   };

// //   // ================= CONDITIONS =================
// //   const isFut = contractType === "FUT";
// //   const isOption = contractType === "CE" || contractType === "PE";
// //   const showExpiryMonth1 = showExpiry1 === "month" && isFut;
// //   const showCallPutMonthly = showExpiry1 === "month" && isOption;
// //   const showCallPutWeekly = showExpiry1 === "week" && isOption;
// //   const showIfTouchPrice = entryOrderType === "LIMIT";

// //   // ================= CSS STYLES =================
// //   const selectStyle = `w-full px-2 py-1.5 rounded-md border text-xs transition-all duration-200
// //     bg-[var(--input-bg)] text-[var(--input-text)] border-[var(--input-border)]
// //     outline-none appearance-none`;

// //   const labelStyle = `block text-[11px] font-medium mb-1 transition-colors duration-200 text-[var(--label-color)]`;
// //   const sectionStyle = "mt-4 w-full";
// //   const cardStyle = `rounded-lg p-3 transition-colors duration-200 bg-[var(--card-bg)] border border-[var(--card-border)]`;
// //   const headingStyle = `text-sm font-semibold transition-colors duration-200 text-[var(--heading-color)]`;
// //   const buttonStyle = `flex items-center gap-1.5 px-3 py-1.5 rounded-md font-medium transition-all duration-300 shadow-md hover:shadow-lg text-xs
// //     bg-[var(--button-primary)] hover:bg-[var(--button-primary-hover)] text-white`;
// //   const resetButtonStyle = `px-4 py-1.5 rounded-md font-medium transition-all duration-200 text-xs
// //     bg-[var(--button-reset-bg)] hover:bg-[var(--button-reset-hover)] text-[var(--text-primary)] border border-[var(--border-color)]`;
// //   const infoButtonStyle = `p-1 rounded-md transition-colors duration-200 hover:bg-gray-200 dark:hover:bg-gray-700 text-[var(--text-muted)]`;
// //   const checkboxLabelStyle = `flex items-center gap-2 text-xs cursor-pointer transition-colors duration-200 text-[var(--text-primary)]`;
// //   const inputStyle = `w-full px-2 py-1.5 rounded-md border text-xs transition-all duration-200
// //     bg-[var(--input-bg)] text-[var(--input-text)] border-[var(--input-border)]
// //     focus:outline-none focus:ring-1 focus:ring-blue-500`;

// //   const optionClass = (darkMode) => {
// //     return darkMode 
// //       ? "bg-gray-700 text-gray-200 hover:bg-gray-600" 
// //       : "bg-white text-gray-900 hover:bg-gray-100";
// //   };

// //   return (
// //     <div className={`h-full w-full overflow-y-auto transition-all duration-300 bg-[var(--bg-primary)]`}>
// //       <div className="p-3">
// //         {/* Header */}
// //         <div className="flex justify-between items-center mb-4">
// //           <button onClick={handleGenerateAlertModel} className={buttonStyle}>
// //             <span className="text-xs">📈 Generate Trading Webhook</span>
// //           </button>
// //           {onClose && (
// //             <button onClick={onClose} className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700">
// //               <FiX size={16} className="text-[var(--text-muted)]" />
// //             </button>
// //           )}
// //         </div>

// //         <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
// //           {/* ========== CONTRACT DETAILS ========== */}
// //           <div className={sectionStyle}>
// //             <div className="flex items-center justify-between mb-2">
// //               <h3 className={headingStyle}>📋 Contract Details</h3>
// //               <button onClick={() => setActiveModal("modal1")} className={infoButtonStyle} type="button">
// //                 <FaRegFileAlt className="text-[10px]" />
// //               </button>
// //             </div>

// //             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
// //               <div>
// //                 <label className={labelStyle}>Exchange</label>
// //                 <select
// //                   className={selectStyle}
// //                   value={exchange}
// //                   onChange={(e) => {
// //                     setExchange(e.target.value);
// //                     setSymbol("");
// //                   }}
// //                 >
// //                   <option value="NSE" className={optionClass(darkMode)}>NSE</option>
// //                   <option value="BSE" className={optionClass(darkMode)}>BSE</option>
// //                 </select>
// //               </div>

// //               <div>
// //                 <label className={labelStyle}>Contract Type</label>
// //                 <select
// //                   className={selectStyle}
// //                   value={contractType}
// //                   onChange={(e) => {
// //                     setContractType(e.target.value);
// //                     setSymbol("");
// //                   }}
// //                 >
// //                   <option value="EQ" className={optionClass(darkMode)}>Equity</option>
// //                   <option value="FUT" className={optionClass(darkMode)}>Future</option>
// //                   <option value="CE" className={optionClass(darkMode)}>Call</option>
// //                   <option value="PE" className={optionClass(darkMode)}>Put</option>
// //                 </select>
// //               </div>

// //               <div>
// //                 <label className={labelStyle}>Symbol</label>
// //                 <input
// //                   ref={symbolInputRef}
// //                   list="symbols"
// //                   type="text"
// //                   placeholder="Search symbol..."
// //                   className={inputStyle}
// //                   value={symbol}
// //                   onChange={handleChange1}
// //                   onFocus={handleInputFocus}
// //                 />
// //                 <datalist id="symbols">
// //                   {Object.entries(list || {}).map(([key, value], index) => (
// //                     <option key={index} value={key} className={optionClass(darkMode)}>{value}</option>
// //                   ))}
// //                 </datalist>
// //               </div>
// //             </div>

// //             {/* Expiry Section */}
// //             {(isFut || isOption) && (
// //               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3">
// //                 <div>
// //                   <label className={labelStyle}>Select Expiry</label>
// //                   <select className={selectStyle} value={showExpiry1} onChange={(e) => setShowExpiry1(e.target.value)}>
// //                     {isFut ? (
// //                       <option value="month" className={optionClass(darkMode)}>Monthly</option>
// //                     ) : (
// //                       <>
// //                         <option value="month" className={optionClass(darkMode)}>Monthly</option>
// //                         <option value="week" className={optionClass(darkMode)}>Weekly</option>
// //                       </>
// //                     )}
// //                   </select>
// //                 </div>

// //                 {(showExpiryMonth1 || showCallPutMonthly) && (
// //                   <div>
// //                     <label className={labelStyle}>Monthly Expiry</label>
// //                     <select
// //                       className={selectStyle}
// //                       value={monthlyExpiry}
// //                       onChange={(e) => {
// //                         const val = Number(e.target.value);
// //                         setMonthlyExpiry(val);
// //                         if (val !== 0) setWeeklyExpiry(0);
// //                       }}
// //                     >
// //                       <option value={0} className={optionClass(darkMode)}>Select</option>
// //                       <option value={1} className={optionClass(darkMode)}>1</option>
// //                       <option value={2} className={optionClass(darkMode)}>2</option>
// //                       <option value={3} className={optionClass(darkMode)}>3</option>
// //                     </select>
// //                   </div>
// //                 )}

// //                 {showCallPutWeekly && (
// //                   <div>
// //                     <label className={labelStyle}>Weekly Expiry</label>
// //                     <select
// //                       className={selectStyle}
// //                       value={weeklyExpiry}
// //                       onChange={(e) => {
// //                         const val = Number(e.target.value);
// //                         setWeeklyExpiry(val);
// //                         if (val !== 0) setMonthlyExpiry(0);
// //                       }}
// //                     >
// //                       <option value={0} className={optionClass(darkMode)}>Select</option>
// //                       <option value={1} className={optionClass(darkMode)}>1</option>
// //                       <option value={2} className={optionClass(darkMode)}>2</option>
// //                       <option value={3} className={optionClass(darkMode)}>3</option>
// //                     </select>
// //                   </div>
// //                 )}

// //                 {(contractType === "CE" || contractType === "PE") && (
// //                   <div>
// //                     <label className={labelStyle}>Exact Strike</label>
// //                     <input
// //                       type="number"
// //                       min="0"
// //                       value={exactStrike}
// //                       onChange={(e) => setExactStrike(parseFloat(e.target.value))}
// //                       onFocus={handleInputFocus}
// //                       className={inputStyle}
// //                     />
// //                   </div>
// //                 )}
// //               </div>
// //             )}
// //           </div>

// //           {/* ========== ORDER SETTINGS ========== */}
// //           <div className={sectionStyle}>
// //             <div className="flex items-center justify-between mb-2">
// //               <h3 className={headingStyle}>⚙️ Order Settings</h3>
// //               <button onClick={() => setActiveModal("modal2")} className={infoButtonStyle} type="button">
// //                 <FaRegFileAlt className="text-[10px]" />
// //               </button>
// //             </div>

// //             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
// //               <div>
// //                 <label className={labelStyle}>Entry Order Type</label>
// //                 <select value={entryOrderType} onChange={(e) => setEntryOrderType(e.target.value)} className={selectStyle}>
// //                   <option value="MARKET" className={optionClass(darkMode)}>Market</option>
// //                   <option value="LIMIT" className={optionClass(darkMode)}>Limit</option>
// //                 </select>
// //               </div>

// //               <div>
// //                 <label className={labelStyle}>Action</label>
// //                 <select value={action} onChange={(e) => setAction(e.target.value)} className={selectStyle}>
// //                   <option value="BUY" className={optionClass(darkMode)}>Buy</option>
// //                   <option value="SELL" className={optionClass(darkMode)}>Sell</option>
// //                   <option value="CLOSE" className={optionClass(darkMode)}>Close</option>
// //                 </select>
// //               </div>

// //               <div>
// //                 <label className={labelStyle}>Expire (Sec)</label>
// //                 <input
// //                   ref={expireInputRef}
// //                   type="number"
// //                   min="0"
// //                   value={expireInSecond}
// //                   onChange={(e) => setExpireInSecond(Number(e.target.value))}
// //                   onFocus={handleInputFocus}
// //                   className={inputStyle}
// //                 />
// //               </div>

// //               <div>
// //                 <label className={labelStyle}>Touch Price</label>
// //                 <input
// //                   ref={touchPriceInputRef}
// //                   type="text"
// //                   value={formatAmount(ifTouchPrice)}
// //                   onChange={(e) => handleNumberChange(setIfTouchPrice, e)}
// //                   onFocus={handleInputFocus}
// //                   className={inputStyle}
// //                 />
// //               </div>

// //               <div>
// //                 <label className={labelStyle}>Quantity Type</label>
// //                 <select 
// //                   value={quantityType} 
// //                   onChange={(e) => {
// //                     setQuantityType(e.target.value);
// //                     setQuantity("0");
// //                   }} 
// //                   className={selectStyle}
// //                 >
// //                   <option value="normal" className={optionClass(darkMode)}>Normal</option>
// //                   <option value="by_risk_percentage" className={optionClass(darkMode)}>By Risk %</option>
// //                   <option value="by_amount" className={optionClass(darkMode)}>By Amount</option>
// //                 </select>
// //               </div>

// //               <div>
// //                 <label className={labelStyle}>
// //                   {quantityType === "normal" ? "Quantity" : quantityType === "by_risk_percentage" ? "Risk %" : "Amount"}
// //                 </label>
// //                 <input
// //                   ref={quantityInputRef}
// //                   type="text"
// //                   min=" 0 "
// //                   value={getDisplayValue()}
// //                   onChange={(e) => {
// //                     let val = e.target.value;
// //                     if (quantityType === "by_risk_percentage") {
// //                       val = val.replace(/[^\d.]/g, "");
// //                       setQuantity(val === "" ? "0" : val);
// //                     } else if (quantityType === "by_amount") {
// //                       val = val.replace(/[^\d.]/g, "");
// //                       setQuantity(val === "" ? "0" : val);
// //                     } else {
// //                       setQuantity(e.target.value);
// //                     }
// //                   }}
// //                   onFocus={handleInputFocus}
// //                   className={inputStyle}
// //                 />
// //               </div>

// //               {showIfTouchPrice && (
// //                 <div>
// //                   <label className={labelStyle}>Price</label>
// //                   <input
// //                     ref={priceInputRef}
// //                     type="text"
// //                     value={formatAmount(price)}
// //                     onChange={(e) => handleNumberChange(setPrice, e)}
// //                     onFocus={handleInputFocus}
// //                     className={inputStyle}
// //                   />
// //                 </div>
// //               )}
// //             </div>
// //           </div>

// //           {/* ========== RISK SETTINGS ========== */}
// //           {action !== "CLOSE" && (
// //             <>
// //               <div className={sectionStyle}>
// //                 <button 
// //                   onClick={handleRiskSetting} 
// //                   type="button"
// //                   className="flex items-center gap-1.5 text-xs font-semibold mb-2 text-[var(--heading-color)] hover:opacity-80"
// //                 >
// //                   🛡️ Risk Settings {showRiskSettings ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
// //                 </button>

// //                 {showRiskSettings && (
// //                   <div className={cardStyle}>
// //                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
// //                       <div>
// //                         <label className={labelStyle}>TP Type</label>
// //                         <select value={tpType} onChange={(e) => setTpType(e.target.value)} className={selectStyle}>
// //                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
// //                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
// //                           <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
// //                         </select>
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>
// //                           {tpType === "BY_POINTS" ? "TP Point" : tpType === "BY_PERCENT" ? "TP %" : "TP Value"}
// //                         </label>
// //                         <input
// //                           ref={tpValueInputRef}
// //                           type="text"
// //                           value={tpType === "BY_PERCENT" ? formatPercentage(tpValue) : tpType === "BY_AMOUNT" ? formatAmount(tpValue) : tpValue}
// //                           onChange={(e) => handleNumberChange(setTpValue, e)}
// //                           onFocus={handleInputFocus}
// //                           className={inputStyle}
// //                         />
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>SL Type</label>
// //                         <select value={slType} onChange={(e) => setSlType(e.target.value)} className={selectStyle}>
// //                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
// //                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
// //                           <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
// //                         </select>
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>
// //                           {slType === "BY_POINTS" ? "SL Point" : slType === "BY_PERCENT" ? "SL %" : "SL Value"}
// //                         </label>
// //                         <input
// //                           ref={slValueInputRef}
// //                           type="text"
// //                           value={slType === "BY_PERCENT" ? formatPercentage(slValue) : slType === "BY_AMOUNT" ? formatAmount(slValue) : slValue}
// //                           onChange={(e) => handleNumberChange(setSlValue, e)}
// //                           onFocus={handleInputFocus}
// //                           className={inputStyle}
// //                         />
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>SL Touch Price</label>
// //                         <input
// //                           type="text"
// //                           value={formatAmount(slIfTouchPrice)}
// //                           onChange={(e) => handleNumberChange(setSlIfTouchPrice, e)}
// //                           onFocus={handleInputFocus}
// //                           className={inputStyle}
// //                         />
// //                       </div>
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>

// //               {/* ========== ADVANCED SETTINGS ========== */}
// //               <div className={sectionStyle}>
// //                 <button 
// //                   onClick={handleAdvanceSetting} 
// //                   type="button"
// //                   className="flex items-center gap-1.5 text-xs font-semibold mb-2 text-[var(--heading-color)] hover:opacity-80"
// //                 >
// //                   🔧 Advanced Settings {showAdvancedSettings ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
// //                 </button>

// //                 {showAdvancedSettings && (
// //                   <div className={cardStyle}>
// //                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
// //                       <div>
// //                         <label className={labelStyle}>Breakeven Type</label>
// //                         <select value={breakevenType} onChange={(e) => setBreakevenType(e.target.value)} className={selectStyle}>
// //                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
// //                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
// //                           <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
// //                         </select>
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>
// //                           {breakevenType === "BY_POINTS" ? "Point" : breakevenType === "BY_PERCENT" ? " %" : "Value"}
// //                         </label>
// //                         <input
// //                           ref={breakevenInputRef}
// //                           type="text"
// //                           value={breakevenType === "BY_PERCENT" ? formatPercentage(breakeven) : breakevenType === "BY_AMOUNT" ? formatAmount(breakeven) : breakeven}
// //                           onChange={(e) => handleNumberChange(setBreakeven, e)}
// //                           onFocus={handleInputFocus}
// //                           className={inputStyle}
// //                         />
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>SL Trail Type</label>
// //                         <select value={slTrailType} onChange={(e) => setSlTrailType(e.target.value)} className={selectStyle}>
// //                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
// //                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
// //                         </select>
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>
// //                           {slTrailType === "BY_POINTS" ? "Trail Point" : "Trail %"}
// //                         </label>
// //                         <input
// //                           ref={slTrailValueInputRef}
// //                           type="text"
// //                           value={slTrailType === "BY_PERCENT" ? formatPercentage(slTrailValue) : slTrailValue}
// //                           onChange={(e) => handleNumberChange(setSlTrailValue, e)}
// //                           onFocus={handleInputFocus}
// //                           className={inputStyle}
// //                         />
// //                       </div>
// //                       <div>
// //                         <label className={labelStyle}>SL Price Move</label>
// //                         <input
// //                           ref={slPriceMoveInputRef}
// //                           type="text"
// //                           value={formatAmount(slPriceMove)}
// //                           onChange={(e) => handleNumberChange(setSlPriceMove, e)}
// //                           onFocus={handleInputFocus}
// //                           className={inputStyle}
// //                         />
// //                       </div>
// //                     </div>

// //                     <div className="flex flex-wrap gap-3 mt-3">
// //                       <label className={checkboxLabelStyle}>
// //                         <input type="checkbox" checked={duplicatePosition} onChange={(e) => setDuplicatePosition(e.target.checked)} />
// //                         Duplicate Position
// //                       </label>
// //                       <label className={checkboxLabelStyle}>
// //                         <input type="checkbox" checked={existingClose} onChange={(e) => setExistingClose(e.target.checked)} />
// //                         Existing Close
// //                       </label>
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>
// //             </>
// //           )}

// //           {/* ========== FOOTER ========== */}
// //           <div className="sticky bottom-0 py-2 mt-4 border-t bg-[var(--bg-footer)] border-[var(--border-color)]">
// //             <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
// //               <div className="text-[11px] text-[var(--text-muted)]">
// //                 {action} • {entryOrderType} • {symbol || "No symbol"}
// //               </div>
// //               <div className="flex gap-2">
// //                 <button onClick={handleExecuteButton} disabled={isLoading} className={`${buttonStyle} ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`} type="button">
// //                   {isLoading ? <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : " Execute"}
// //                 </button>
// //                 <button onClick={handleReset} type="button" className={resetButtonStyle}>Reset</button>
// //               </div>
// //             </div>
// //           </div>
// //         </form>
// //       </div>

// //       {/* ========== MODALS ========== */}
// //       <Modal show={activeModal === "alert-model"} onHide={handleClose} centered size="lg">
// //         <Modal.Body className="p-0">
// //           <div className="flex justify-between gap-2 px-3 py-2 border-b bg-gray-100 dark:bg-gray-800 rounded-t-md">
// //             <button onClick={handleCopyJSON} className="bg-blue-500 text-white px-3 py-1 rounded-md text-xs" type="button">📋 Copy JSON</button>
// //             <button onClick={handleCopyURL} className="bg-green-500 text-white px-3 py-1 rounded-md text-xs" type="button">🔗 Copy Webhook URL</button>
// //           </div>
// //           <div className="p-3">
// //             <div className="flex gap-2 mb-3">
// //               {["normal", "indicator", "strategy"].map((tab) => (
// //                 <button key={tab} onClick={() => setActiveTab(tab)} className={`px-3 py-1.5 rounded-md text-xs ${activeTab === tab ? 'bg-blue-500 text-white' : 'bg-gray-200 dark:bg-gray-700'}`} type="button">
// //                   {tab.toUpperCase()}
// //                 </button>
// //               ))}
// //             </div>
// //             <pre className="p-3 rounded-md overflow-auto max-h-[350px] text-xs bg-gray-900 text-green-400">
// //               {activeTab === "strategy" ? JSON.stringify(strategyJson, null, 2) : JSON.stringify(generatAlertData, null, 2)}
// //             </pre>
// //           </div>
// //           <div className="flex justify-end px-3 py-2 border-t bg-gray-100 dark:bg-gray-800 rounded-b-md">
// //             <Button variant="secondary" onClick={handleClose} className="px-3 py-1 text-xs">Close</Button>
// //           </div>
// //         </Modal.Body>
// //       </Modal>

// //       {/* Info Modals */}
// //       {["modal1", "modal2", "modal3", "modal4"].map((modalId) => (
// //         <Modal key={modalId} show={activeModal === modalId} onHide={handleClose} centered>
// //           <Modal.Header closeButton className="py-2 bg-gray-100 dark:bg-gray-800">
// //             <Modal.Title className="text-sm">
// //               {modalId === "modal1" && "📋 Contract Overview"}
// //               {modalId === "modal2" && "⚙️ Order Settings Overview"}
// //               {modalId === "modal3" && "🛡️ Risk Settings Overview"}
// //               {modalId === "modal4" && "🔧 Advanced Settings Overview"}
// //             </Modal.Title>
// //           </Modal.Header>
// //           <Modal.Body className="p-3">
// //             <div className="space-y-2 text-xs">
// //               {modalId === "modal1" && (<><p><strong>Exchange:</strong> NSE and BSE supported</p><p><strong>Contract Type:</strong> Equity, Future, Call, Put</p></>)}
// //               {modalId === "modal2" && (<><p><strong>Order Type:</strong> Market and Limit orders</p><p><strong>Action:</strong> Buy, Sell, or Close</p></>)}
// //               {modalId === "modal3" && (<><p><strong>TP/SL Types:</strong> Normal, Points, or Percentage based</p></>)}
// //               {modalId === "modal4" && (<><p><strong>Breakeven:</strong> Shifts SL to entry price</p><p><strong>Trailing SL:</strong> Auto adjusts SL</p></>)}
// //             </div>
// //           </Modal.Body>
// //           <Modal.Footer className="py-2 bg-gray-100 dark:bg-gray-800">
// //             <Button size="sm" variant="secondary" onClick={handleClose}>Close</Button>
// //           </Modal.Footer>
// //         </Modal>
// //       ))}
// //     </div>
// //   );
// // };

// // export default AlertWindow;




// // =====================================================================
// // COMPLETE FIXED ALERT WINDOW - With ₹ and % symbols with space
// // =====================================================================
// import React, { useState, useEffect, useRef } from "react";
// import { FaRegFileAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";
// import { FiX } from "react-icons/fi";
// import { Button, Modal } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { executeAlertDataService } from "../apiservice/executeAlertDataService";
// import { fetchSymbolService } from "../apiservice/fetchSymbolService";
// import { useAuth } from "../../context/auth";
// import { sendGlobalWS } from "../../context/UseWebSocketContext";

// const AlertWindow = ({ onClose, darkMode = false }) => {
//   const { getSecKey, getLoginToken, getGoogleAuthToken } = useAuth();
//   const token = getLoginToken() || getGoogleAuthToken();
  
//   // ================= ALL STATES =================
//   const [activeModal, setActiveModal] = useState(null);
//   const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
//   const [showRiskSettings, setShowRiskSettings] = useState(false);
//   const [activeTab, setActiveTab] = useState("normal");
//   const [isLoading, setIsLoading] = useState(false);
  
//   // Form States
//   const [symbol, setSymbol] = useState("");
//   const [exchange, setExchange] = useState("NSE");
//   const [contractType, setContractType] = useState("EQ");
//   const [monthlyExpiry, setMonthlyExpiry] = useState(0);
//   const [weeklyExpiry, setWeeklyExpiry] = useState(0);
//   const [exactStrike, setExactStrike] = useState(0);
//   const [duplicatePosition, setDuplicatePosition] = useState(false);
//   const [expireInSecond, setExpireInSecond] = useState(0);
//   const [existingClose, setExistingClose] = useState(false);
//   const [action, setAction] = useState("BUY");
//   const [quantityType, setQuantityType] = useState("normal");
//   const [quantity, setQuantity] = useState("0");
//   const [entryOrderType, setEntryOrderType] = useState("MARKET");
//   const [price, setPrice] = useState(0);
//   const [ifTouchPrice, setIfTouchPrice] = useState(0);
//   const [tpType, setTpType] = useState("BY_POINTS");
//   const [tpValue, setTpValue] = useState(0);
//   const [slType, setSlType] = useState("BY_POINTS");
//   const [slValue, setSlValue] = useState(0);
//   const [slIfTouchPrice, setSlIfTouchPrice] = useState(0);
//   const [breakevenType, setBreakevenType] = useState("BY_POINTS");
//   const [breakeven, setBreakeven] = useState(0);
//   const [slTrailType, setSlTrailType] = useState("BY_POINTS");
//   const [slTrailValue, setSlTrailValue] = useState(0);
//   const [slPriceMove, setSlPriceMove] = useState(0);
//   const [showExpiry1, setShowExpiry1] = useState("month");
//   const [list, setList] = useState({});
//   const [listsCache, setListsCache] = useState({});

//   // Refs
//   const symbolInputRef = useRef(null);
//   const quantityInputRef = useRef(null);
//   const priceInputRef = useRef(null);
//   const tpValueInputRef = useRef(null);
//   const slValueInputRef = useRef(null);
//   const breakevenInputRef = useRef(null);
//   const slTrailValueInputRef = useRef(null);
//   const slPriceMoveInputRef = useRef(null);
//   const expireInputRef = useRef(null);
//   const touchPriceInputRef = useRef(null);

//   // Apply dark mode
//   useEffect(() => {
//     if (darkMode) {
//       document.body.classList.add('dark-mode');
//     } else {
//       document.body.classList.remove('dark-mode');
//     }
//   }, [darkMode]);

//   const handleClose = () => setActiveModal(null);
//   const handleInputFocus = (e) => e.target.select();

//   // Fetch symbols
//   const keyMapping = {
//     "BSE:Equity": "BSE_EQ", "BSE:Futures": "BSE_FUT", "BSE:Options": "BSE_OPT", "BSE:Call/Put": "BSE_OPT",
//     "NSE:Equity": "NSE_EQ", "NSE:Futures": "NSE_FUT", "NSE:Options": "NSE_OPT", "NSE:Call/Put": "NSE_OPT",
//   };

//   useEffect(() => {
//     if (exchange && contractType && token) {
//       const rawKey = `${exchange}:${contractType}`;
//       const key = keyMapping[rawKey] || rawKey;

//       if (listsCache[key]) {
//         setList(listsCache[key]);
//         return;
//       }

//       const fetchSymbols = async () => {
//         const payload = { exchange, contract_type: contractType };
//         const result = await fetchSymbolService(token, payload);
//         if (result.success) {
//           const symbols = result.data?.data;
//           const symbolDict = symbols.reduce((acc, item) => {
//             acc[item] = item;
//             return acc;
//           }, {});
//           setListsCache((prev) => ({ ...prev, [key]: symbolDict }));
//           setList(symbolDict);
//         } else {
//           setList({});
//         }
//       };
//       fetchSymbols();
//     } else {
//       setList({});
//     }
//   }, [exchange, contractType, token]);

//   const handleChange1 = (e) => {
//     setSymbol(e.target.value.toUpperCase());
//   };

//   // const formatSymbolWithSpace = (sym) => {
//   //   if (!sym) return "";
//   //   return sym.split('').join(' ');
//   // };

//   // API Data
//   const data = {
//     symbol: symbol,
//     exchange: exchange,
//     contract_type: contractType,
//     monthly_expiry: Number(monthlyExpiry),
//     weekly_expiry: Number(weeklyExpiry),
//     exact_strike: Number(exactStrike),
//     expire_in_second: Number(expireInSecond),
//     duplicate_position: duplicatePosition,
//     action: action,
//     quantity: action === "CLOSE" ? 1 : Number(quantity || 0),
//     quantity_type: quantityType === "normal" ? "NORMAL" : quantityType === "by_risk_percentage" ? "BY_RISK_PERCENTAGE" : "BY_AMOUNT",
//     entry_order_type: entryOrderType,
//     price: Number(price),
//     update_order_id: "",
//     update_type: "",
//     if_touch_price: Number(ifTouchPrice),
//     tp_type: tpType?.toUpperCase() || "NORMAL",
//     tp_value: Number(tpValue),
//     sl_type: slType?.toUpperCase() || "NORMAL",
//     sl_value: Number(slValue),
//     sl_if_touch_price: Number(slIfTouchPrice),
//     breakeven_type: breakevenType?.toUpperCase() || "NORMAL",
//     breakeven: Number(breakeven),
//     sl_trail_type: slTrailType,
//     sl_trail_value: Number(slTrailValue),
//     sl_price_move: Number(slPriceMove),
//     existing_close: existingClose,
//   };

//   const generatAlertData = { ...data };
//   const strategyJson = {
//     ...data,
//     action: "{{strategy.order.action}}",
//     quantity: "{{strategy.order.contracts}}",
//   };

//   // Validation
//   const validateExecute = () => {
//     if (!symbol || symbol.trim() === "") return "❌ Symbol is required!";
//     if (action !== "CLOSE" && (!quantity || Number(quantity) <= 0)) return "❌ Quantity must be greater than 0!";
//     return null;
//   };

//   // Get security key
//   const getSecurityKey = () => {
//     try {
//       let key = getSecKey();
//       if (key && key !== "undefined" && key !== "null" && key.length > 10) return key;
//       key = localStorage.getItem('sec_key');
//       if (key && key !== "undefined" && key !== "null" && key.length > 10) return key;
//       key = localStorage.getItem('session-token');
//       if (key && key.length > 10) return key;
//       return null;
//     } catch (error) {
//       console.error("Error getting security key:", error);
//       return null;
//     }
//   };

//   // Execute button
//   const handleExecuteButton = async () => {
//     const secKey = getSecurityKey();
//     const validateError = validateExecute();
//     if (validateError) {
//       toast.warning(validateError);
//       return;
//     }
//     if (!secKey) {
//       toast.error("🔑 Security key not found! Please refresh.");
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const response = await executeAlertDataService(data, secKey);
//       if (response.status === 200) {
//         if (response?.data?.error === false) {
//           toast.success(response?.data?.data || "Order executed successfully!");
//           sendGlobalWS({ r: "orders" });
//           sendGlobalWS({ r: "positions" });
//           sendGlobalWS({ r: "alerts" });
//         } else {
//           toast.error(response?.data?.data || "Execution failed");
//         }
//       } else {
//         toast.error(response?.data?.data || "Execution failed");
//       }
//     } catch (error) {
//       console.error("Execute error:", error);
//       toast.error(error?.response?.data?.data || "Something went wrong");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Reset
//   const handleReset = () => {
//     setSymbol("");
//     setContractType("EQ");
//     setExchange("NSE");
//     setMonthlyExpiry(0);
//     setWeeklyExpiry(0);
//     setExactStrike(0);
//     setDuplicatePosition(false);
//     setExpireInSecond(0);
//     setExistingClose(false);
//     setQuantityType("normal");
//     setQuantity("0");
//     setEntryOrderType("MARKET");
//     setPrice(0);
//     setIfTouchPrice(0);
//     setTpType("BY_POINTS");
//     setTpValue(0);
//     setSlType("BY_POINTS");
//     setSlValue(0);
//     setSlIfTouchPrice(0);
//     setBreakevenType("BY_POINTS");
//     setBreakeven(0);
//     setSlTrailType("BY_POINTS");
//     setSlTrailValue(0);
//     setSlPriceMove(0);
//     setShowExpiry1("month");
//     setShowRiskSettings(false);
//     setShowAdvancedSettings(false);
//     toast.info("🔄 Form reset successfully!");
//   };

//   const handleCopyJSON = () => {
//     const jsonString = activeTab === "strategy" 
//       ? JSON.stringify(strategyJson, null, 2)
//       : JSON.stringify(generatAlertData, null, 2);
//     navigator.clipboard.writeText(jsonString);
//     toast.success("📋 JSON copied!");
//   };

//   const handleCopyURL = () => {
//     const secKey = getSecurityKey();
//     if (secKey) {
//       navigator.clipboard.writeText(`https://api.algocontroller.com/v2/sendAlert/${secKey}`);
//       toast.success("🔗 Webhook URL copied!");
//     } else {
//       toast.error("Cannot copy URL: Security key not found!");
//     }
//   };

//   const handleGenerateAlertModel = () => {
//     if (!symbol || symbol.trim() === "" || quantity <= 0) {
//       toast.warning("⚠️ Please select Symbol and Quantity");
//     } else {
//       setActiveModal("alert-model");
//     }
//   };

//   const handleRiskSetting = (e) => {
//     e.preventDefault();
//     setShowRiskSettings(!showRiskSettings);
//   };

//   const handleAdvanceSetting = (e) => {
//     e.preventDefault();
//     setShowAdvancedSettings(!showAdvancedSettings);
//   };

//   // Conditions
//   const isFut = contractType === "FUT";
//   const isOption = contractType === "CE" || contractType === "PE";
//   const showExpiryMonth1 = showExpiry1 === "month" && isFut;
//   const showCallPutMonthly = showExpiry1 === "month" && isOption;
//   const showCallPutWeekly = showExpiry1 === "week" && isOption;
//   const showIfTouchPrice = entryOrderType === "LIMIT";

//   // CSS Styles
//   const selectStyle = `w-full px-2 py-1.5 rounded-md border text-xs transition-all duration-200
//     bg-[var(--input-bg)] text-[var(--input-text)] border-[var(--input-border)]
//     outline-none appearance-none`;

//   const labelStyle = `block text-[11px] font-medium mb-1 transition-colors duration-200 text-[var(--label-color)]`;
//   const sectionStyle = "mt-4 w-full";
//   const cardStyle = `rounded-lg p-3 transition-colors duration-200 bg-[var(--card-bg)] border border-[var(--card-border)]`;
//   const headingStyle = `text-sm font-semibold transition-colors duration-200 text-[var(--heading-color)]`;
//   const buttonStyle = `flex items-center gap-1.5 px-3 py-1.5 rounded-md font-medium transition-all duration-300 shadow-md hover:shadow-lg text-xs
//     bg-[var(--button-primary)] hover:bg-[var(--button-primary-hover)] text-white`;
//   const resetButtonStyle = `px-4 py-1.5 rounded-md font-medium transition-all duration-200 text-xs
//     bg-[var(--button-reset-bg)] hover:bg-[var(--button-reset-hover)] text-[var(--text-primary)] border border-[var(--border-color)]`;
//   const infoButtonStyle = `p-1 rounded-md transition-colors duration-200 hover:bg-gray-200 dark:hover:bg-gray-700 text-[var(--text-muted)]`;
//   const checkboxLabelStyle = `flex items-center gap-2 text-xs cursor-pointer transition-colors duration-200 text-[var(--text-primary)]`;
//   const inputStyle = `w-full px-2 py-1.5 rounded-md border text-xs transition-all duration-200
//     bg-[var(--input-bg)] text-[var(--input-text)] border-[var(--input-border)]
//     focus:outline-none focus:ring-1 focus:ring-blue-500`;

//   const optionClass = (darkMode) => darkMode ? "bg-gray-700 text-gray-200 hover:bg-gray-600" : "bg-white text-gray-900 hover:bg-gray-100";

//   return (
//     <div className={`h-full w-full overflow-y-auto transition-all duration-300 bg-[var(--bg-primary)]`}>
//       <div className="p-3">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-4">
//           <button onClick={handleGenerateAlertModel} className={buttonStyle}>
//             <span className="text-xs">📈 Generate Trading Webhook</span>
//           </button>
//           {onClose && (
//             <button onClick={onClose} className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700">
//               <FiX size={16} className="text-[var(--text-muted)]" />
//             </button>
//           )}
//         </div>

//         <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
          
//           {/* ========== CONTRACT DETAILS ========== */}
//           <div className={sectionStyle}>
//             <div className="flex items-center justify-between mb-2">
//               <h3 className={headingStyle}>📋 Contract Details</h3>
//               <button onClick={() => setActiveModal("modal1")} className={infoButtonStyle} type="button">
//                 <FaRegFileAlt className="text-[10px]" />
//               </button>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
//               <div>
//                 <label className={labelStyle}>Exchange</label>
//                 <select className={selectStyle} value={exchange} onChange={(e) => { setExchange(e.target.value); setSymbol(""); }}>
//                   <option value="NSE" className={optionClass(darkMode)}>NSE</option>
//                   <option value="BSE" className={optionClass(darkMode)}>BSE</option>
//                 </select>
//               </div>

//               <div>
//                 <label className={labelStyle}>Contract Type</label>
//                 <select className={selectStyle} value={contractType} onChange={(e) => { setContractType(e.target.value); setSymbol(""); }}>
//                   <option value="EQ" className={optionClass(darkMode)}>Equity</option>
//                   <option value="FUT" className={optionClass(darkMode)}>Future</option>
//                   <option value="CE" className={optionClass(darkMode)}>Call</option>
//                   <option value="PE" className={optionClass(darkMode)}>Put</option>
//                 </select>
//               </div>

//               <div>
//                 <label className={labelStyle}>Symbol</label>
//                 <input ref={symbolInputRef} list="symbols" type="text" placeholder="Search symbol..." className={inputStyle} value={symbol} onChange={handleChange1} onFocus={handleInputFocus} />
//                 <datalist id="symbols">
//                   {Object.entries(list || {}).map(([key, value], index) => (
//                     <option key={index} value={key} className={optionClass(darkMode)}>
//                       ({key})
//                     </option>
//                   ))}
//                 </datalist>
//               </div>
//             </div>

//             {/* Expiry Section */}
//             {(isFut || isOption) && (
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3">
//                 <div>
//                   <label className={labelStyle}>Select Expiry</label>
//                   <select className={selectStyle} value={showExpiry1} onChange={(e) => setShowExpiry1(e.target.value)}>
//                     {isFut ? (
//                       <option value="month" className={optionClass(darkMode)}>Monthly</option>
//                     ) : (
//                       <>
//                         <option value="month" className={optionClass(darkMode)}>Monthly</option>
//                         <option value="week" className={optionClass(darkMode)}>Weekly</option>
//                       </>
//                     )}
//                   </select>
//                 </div>

//                 {(showExpiryMonth1 || showCallPutMonthly) && (
//                   <div>
//                     <label className={labelStyle}>Monthly Expiry</label>
//                     <select className={selectStyle} value={monthlyExpiry} onChange={(e) => { const val = Number(e.target.value); setMonthlyExpiry(val); if (val !== 0) setWeeklyExpiry(0); }}>
//                       <option value={0} className={optionClass(darkMode)}>Select</option>
//                       <option value={1} className={optionClass(darkMode)}>1</option>
//                       <option value={2} className={optionClass(darkMode)}>2</option>
//                       <option value={3} className={optionClass(darkMode)}>3</option>
//                     </select>
//                   </div>
//                 )}

//                 {showCallPutWeekly && (
//                   <div>
//                     <label className={labelStyle}>Weekly Expiry</label>
//                     <select className={selectStyle} value={weeklyExpiry} onChange={(e) => { const val = Number(e.target.value); setWeeklyExpiry(val); if (val !== 0) setMonthlyExpiry(0); }}>
//                       <option value={0} className={optionClass(darkMode)}>Select</option>
//                       <option value={1} className={optionClass(darkMode)}>1</option>
//                       <option value={2} className={optionClass(darkMode)}>2</option>
//                       <option value={3} className={optionClass(darkMode)}>3</option>
//                     </select>
//                   </div>
//                 )}

//                 {(contractType === "CE" || contractType === "PE") && (
//                   <div>
//                     <label className={labelStyle}>Exact Strike</label>
//                     <input type="number" min="0" value={exactStrike} onChange={(e) => setExactStrike(parseFloat(e.target.value))} onFocus={handleInputFocus} className={inputStyle} />
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* ========== ORDER SETTINGS (FIXED) ========== */}
//           <div className={sectionStyle}>
//             <div className="flex items-center justify-between mb-2">
//               <h3 className={headingStyle}>⚙️ Order Settings</h3>
//               <button onClick={() => setActiveModal("modal2")} className={infoButtonStyle} type="button">
//                 <FaRegFileAlt className="text-[10px]" />
//               </button>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
//               <div>
//                 <label className={labelStyle}>Entry Order Type</label>
//                 <select value={entryOrderType} onChange={(e) => setEntryOrderType(e.target.value)} className={selectStyle}>
//                   <option value="MARKET" className={optionClass(darkMode)}>Market</option>
//                   <option value="LIMIT" className={optionClass(darkMode)}>Limit</option>
//                 </select>
//               </div>

//               <div>
//                 <label className={labelStyle}>Action</label>
//                 <select value={action} onChange={(e) => setAction(e.target.value)} className={selectStyle}>
//                   <option value="BUY" className={optionClass(darkMode)}>Buy</option>
//                   <option value="SELL" className={optionClass(darkMode)}>Sell</option>
//                   <option value="CLOSE" className={optionClass(darkMode)}>Close</option>
//                 </select>
//               </div>

//               <div>
//                 <label className={labelStyle}>Expire (Sec)</label>
//                 <input ref={expireInputRef} type="number" min="0" value={expireInSecond} onChange={(e) => setExpireInSecond(Number(e.target.value))} onFocus={handleInputFocus} className={inputStyle} />
//               </div>

//               <div>
//                 <label className={labelStyle}>Touch Price</label>
//                 <input ref={touchPriceInputRef} type="text" value={ifTouchPrice ? `₹ ${ifTouchPrice}` : "₹ 0"} onChange={(e) => {
//                   let val = e.target.value.replace(/[^\d.]/g, "");
//                   setIfTouchPrice(val === "" ? 0 : Number(val));
//                 }} onFocus={handleInputFocus} className={inputStyle} />
//               </div>

//               <div>
//                 <label className={labelStyle}>Quantity Type</label>
//                 <select value={quantityType} onChange={(e) => { setQuantityType(e.target.value); setQuantity("0"); }} className={selectStyle}>
//                   <option value="normal" className={optionClass(darkMode)}>Normal</option>
//                   <option value="by_risk_percentage" className={optionClass(darkMode)}>By Risk %</option>
//                   <option value="by_amount" className={optionClass(darkMode)}>By Amount</option>
//                 </select>
//               </div>

//               <div>
//                 <label className={labelStyle}>
//                   {quantityType === "normal" ? "Quantity" : quantityType === "by_risk_percentage" ? "Risk %" : "Amount"}
//                 </label>
//                 <input ref={quantityInputRef} type="text" value={
//                   quantityType === "by_risk_percentage" ? (quantity ? `${quantity} %` : "0 %") :
//                   quantityType === "by_amount" ? (quantity ? `₹ ${quantity}` : "₹ 0") : quantity
//                 } onChange={(e) => {
//                   let val = e.target.value;
//                   if (quantityType === "by_risk_percentage") {
//                     val = val.replace(/[^\d.]/g, "");
//                     setQuantity(val === "" ? "0" : val);
//                   } else if (quantityType === "by_amount") {
//                     val = val.replace(/[^\d.]/g, "");
//                     setQuantity(val === "" ? "0" : val);
//                   } else {
//                     setQuantity(e.target.value);
//                   }
//                 }} onFocus={handleInputFocus} className={inputStyle} />
//               </div>

//               {showIfTouchPrice && (
//                 <div>
//                   <label className={labelStyle}>Price</label>
//                   <input ref={priceInputRef} type="text" value={price ? `₹ ${price}` : "₹ 0"} onChange={(e) => {
//                     let val = e.target.value.replace(/[^\d.]/g, "");
//                     setPrice(val === "" ? 0 : Number(val));
//                   }} onFocus={handleInputFocus} className={inputStyle} />
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* ========== RISK SETTINGS ========== */}
//           {action !== "CLOSE" && (
//             <>
//               <div className={sectionStyle}>
//                 <button onClick={handleRiskSetting} type="button" className="flex items-center gap-1.5 text-xs font-semibold mb-2 text-[var(--heading-color)] hover:opacity-80">
//                   🛡️ Risk Settings {showRiskSettings ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
//                 </button>

//                 {showRiskSettings && (
//                   <div className={cardStyle}>
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
//                       <div>
//                         <label className={labelStyle}>TP Type</label>
//                         <select value={tpType} onChange={(e) => setTpType(e.target.value)} className={selectStyle}>
//                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
//                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
//                           <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
//                         </select>
//                       </div>
//                       <div>
//                         <label className={labelStyle}>{tpType === "BY_POINTS" ? "TP Point" : tpType === "BY_PERCENT" ? "TP %" : "TP Value"}</label>
//                         <input ref={tpValueInputRef} type="text" value={tpType === "BY_PERCENT" ? (tpValue ? `${tpValue} %` : "0 %") : tpType === "BY_AMOUNT" ? (tpValue ? `₹ ${tpValue}` : "₹ 0") : tpValue} onChange={(e) => {
//                           let val = e.target.value.replace(/[^\d.]/g, "");
//                           setTpValue(val === "" ? 0 : Number(val));
//                         }} onFocus={handleInputFocus} className={inputStyle} />
//                       </div>
//                       <div>
//                         <label className={labelStyle}>SL Type</label>
//                         <select value={slType} onChange={(e) => setSlType(e.target.value)} className={selectStyle}>
//                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
//                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
//                           <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
//                         </select>
//                       </div>
//                       <div>
//                         <label className={labelStyle}>{slType === "BY_POINTS" ? "SL Point" : slType === "BY_PERCENT" ? "SL %" : "SL Value"}</label>
//                         <input ref={slValueInputRef} type="text" value={slType === "BY_PERCENT" ? (slValue ? `${slValue} %` : "0 %") : slType === "BY_AMOUNT" ? (slValue ? `₹ ${slValue}` : "₹ 0") : slValue} onChange={(e) => {
//                           let val = e.target.value.replace(/[^\d.]/g, "");
//                           setSlValue(val === "" ? 0 : Number(val));
//                         }} onFocus={handleInputFocus} className={inputStyle} />
//                       </div>
//                       <div>
//                         <label className={labelStyle}>SL Touch Price</label>
//                         <input type="text" value={slIfTouchPrice ? `₹ ${slIfTouchPrice}` : "₹ 0"} onChange={(e) => {
//                           let val = e.target.value.replace(/[^\d.]/g, "");
//                           setSlIfTouchPrice(val === "" ? 0 : Number(val));
//                         }} onFocus={handleInputFocus} className={inputStyle} />
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* ========== ADVANCED SETTINGS ========== */}
//               <div className={sectionStyle}>
//                 <button onClick={handleAdvanceSetting} type="button" className="flex items-center gap-1.5 text-xs font-semibold mb-2 text-[var(--heading-color)] hover:opacity-80">
//                   🔧 Advanced Settings {showAdvancedSettings ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
//                 </button>

//                 {showAdvancedSettings && (
//                   <div className={cardStyle}>
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
//                       <div>
//                         <label className={labelStyle}>Breakeven Type</label>
//                         <select value={breakevenType} onChange={(e) => setBreakevenType(e.target.value)} className={selectStyle}>
//                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
//                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
//                           <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
//                         </select>
//                       </div>
//                       <div>
//                         <label className={labelStyle}>{breakevenType === "BY_POINTS" ? "Point" : breakevenType === "BY_PERCENT" ? "%" : "Value"}</label>
//                         <input ref={breakevenInputRef} type="text" value={breakevenType === "BY_PERCENT" ? (breakeven ? `${breakeven} %` : "0 %") : breakevenType === "BY_AMOUNT" ? (breakeven ? `₹ ${breakeven}` : "₹ 0") : breakeven} onChange={(e) => {
//                           let val = e.target.value.replace(/[^\d.]/g, "");
//                           setBreakeven(val === "" ? 0 : Number(val));
//                         }} onFocus={handleInputFocus} className={inputStyle} />
//                       </div>
//                       <div>
//                         <label className={labelStyle}>SL Trail Type</label>
//                         <select value={slTrailType} onChange={(e) => setSlTrailType(e.target.value)} className={selectStyle}>
//                           <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
//                           <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
//                         </select>
//                       </div>
//                       <div>
//                         <label className={labelStyle}>{slTrailType === "BY_POINTS" ? "Trail Point" : "Trail %"}</label>
//                         <input ref={slTrailValueInputRef} type="text" value={slTrailType === "BY_PERCENT" ? (slTrailValue ? `${slTrailValue} %` : "0 %") : slTrailValue} onChange={(e) => {
//                           let val = e.target.value.replace(/[^\d.]/g, "");
//                           setSlTrailValue(val === "" ? 0 : Number(val));
//                         }} onFocus={handleInputFocus} className={inputStyle} />
//                       </div>
//                       <div>
//                         <label className={labelStyle}>SL Price Move</label>
//                         <input ref={slPriceMoveInputRef} type="text" value={slPriceMove ? `₹ ${slPriceMove}` : "₹ 0"} onChange={(e) => {
//                           let val = e.target.value.replace(/[^\d.]/g, "");
//                           setSlPriceMove(val === "" ? 0 : Number(val));
//                         }} onFocus={handleInputFocus} className={inputStyle} />
//                       </div>
//                     </div>

//                     <div className="flex flex-wrap gap-3 mt-3">
//                       <label className={checkboxLabelStyle}>
//                         <input type="checkbox" checked={duplicatePosition} onChange={(e) => setDuplicatePosition(e.target.checked)} />
//                         Duplicate Position
//                       </label>
//                       <label className={checkboxLabelStyle}>
//                         <input type="checkbox" checked={existingClose} onChange={(e) => setExistingClose(e.target.checked)} />
//                         Existing Close
//                       </label>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </>
//           )}

//           {/* ========== FOOTER ========== */}
//           <div className="sticky bottom-0 py-2 mt-4 border-t bg-[var(--bg-footer)] border-[var(--border-color)]">
//             <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
//               <div className="text-[11px] text-[var(--text-muted)]">
//                 {action} • {entryOrderType} • {symbol || "No symbol"}
//               </div>
//               <div className="flex gap-2">
//                 <button onClick={handleExecuteButton} disabled={isLoading} className={`${buttonStyle} ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`} type="button">
//                   {isLoading ? <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : "Execute"}
//                 </button>
//                 <button onClick={handleReset} type="button" className={resetButtonStyle}>Reset</button>
//               </div>
//             </div>
//           </div>
//         </form>
//       </div>

//       {/* Modals - same as before */}
//       <Modal show={activeModal === "alert-model"} onHide={handleClose} centered size="lg">
//         <Modal.Body className="p-0">
//           <div className="flex justify-between gap-2 px-3 py-2 border-b bg-gray-100 dark:bg-gray-800 rounded-t-md">
//             <button onClick={handleCopyJSON} className="bg-blue-500 text-white px-3 py-1 rounded-md text-xs" type="button">📋 Copy JSON</button>
//             <button onClick={handleCopyURL} className="bg-green-500 text-white px-3 py-1 rounded-md text-xs" type="button">🔗 Copy Webhook URL</button>
//           </div>
//           <div className="p-3">
//             <div className="flex gap-2 mb-3">
//               {["normal", "indicator", "strategy"].map((tab) => (
//                 <button key={tab} onClick={() => setActiveTab(tab)} className={`px-3 py-1.5 rounded-md text-xs ${activeTab === tab ? 'bg-blue-500 text-white' : 'bg-gray-200 dark:bg-gray-700'}`} type="button">
//                   {tab.toUpperCase()}
//                 </button>
//               ))}
//             </div>
//             <pre className="p-3 rounded-md overflow-auto max-h-[350px] text-xs bg-gray-900 text-green-400">
//               {activeTab === "strategy" ? JSON.stringify(strategyJson, null, 2) : JSON.stringify(generatAlertData, null, 2)}
//             </pre>
//           </div>
//           <div className="flex justify-end px-3 py-2 border-t bg-gray-100 dark:bg-gray-800 rounded-b-md">
//             <Button variant="secondary" onClick={handleClose} className="px-3 py-1 text-xs">Close</Button>
//           </div>
//         </Modal.Body>
//       </Modal>

//       {/* Info Modals */}
//       {["modal1", "modal2", "modal3", "modal4"].map((modalId) => (
//         <Modal key={modalId} show={activeModal === modalId} onHide={handleClose} centered>
//           <Modal.Header closeButton className="py-2 bg-gray-100 dark:bg-gray-800">
//             <Modal.Title className="text-sm">
//               {modalId === "modal1" && "📋 Contract Overview"}
//               {modalId === "modal2" && "⚙️ Order Settings Overview"}
//               {modalId === "modal3" && "🛡️ Risk Settings Overview"}
//               {modalId === "modal4" && "🔧 Advanced Settings Overview"}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="p-3">
//             <div className="space-y-2 text-xs">
//               {modalId === "modal1" && (<><p><strong>Exchange:</strong> NSE and BSE supported</p><p><strong>Contract Type:</strong> Equity, Future, Call, Put</p></>)}
//               {modalId === "modal2" && (<><p><strong>Order Type:</strong> Market and Limit orders</p><p><strong>Action:</strong> Buy, Sell, or Close</p></>)}
//               {modalId === "modal3" && (<><p><strong>TP/SL Types:</strong> Normal, Points, or Percentage based</p></>)}
//               {modalId === "modal4" && (<><p><strong>Breakeven:</strong> Shifts SL to entry price</p><p><strong>Trailing SL:</strong> Auto adjusts SL</p></>)}
//             </div>
//           </Modal.Body>
//           <Modal.Footer className="py-2 bg-gray-100 dark:bg-gray-800">
//             <Button size="sm" variant="secondary" onClick={handleClose}>Close</Button>
//           </Modal.Footer>
//         </Modal>
//       ))}
//     </div>
//   );
// };

// export default AlertWindow;





// =====================================================================
// COMPLETE FIXED ALERT WINDOW - No Infinite Loop
// =====================================================================
import React, { useState, useEffect, useRef } from "react";
import { FaRegFileAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { executeAlertDataService } from "../apiservice/executeAlertDataService";
import { fetchSymbolService } from "../apiservice/fetchSymbolService";
import { useAuth } from "../../context/auth";
import { sendGlobalWS } from "../../context/UseWebSocketContext";

const AlertWindow = ({ onClose, darkMode = false }) => {
  const { getSecKey, getLoginToken, getGoogleAuthToken } = useAuth();
  const token = getLoginToken() || getGoogleAuthToken();
  
  // ================= ALL STATES =================
  const [activeModal, setActiveModal] = useState(null);
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [showRiskSettings, setShowRiskSettings] = useState(false);
  const [activeTab, setActiveTab] = useState("normal");
  const [isLoading, setIsLoading] = useState(false);
  
  // Form States
  const [symbol, setSymbol] = useState("");
  const [exchange, setExchange] = useState("NSE");
  const [contractType, setContractType] = useState("EQ");
  const [monthlyExpiry, setMonthlyExpiry] = useState(0);
  const [weeklyExpiry, setWeeklyExpiry] = useState(0);
  const [exactStrike, setExactStrike] = useState(0);
  const [duplicatePosition, setDuplicatePosition] = useState(false);
  const [expireInSecond, setExpireInSecond] = useState(0);
  const [existingClose, setExistingClose] = useState(false);
  const [action, setAction] = useState("BUY");
  const [quantityType, setQuantityType] = useState("normal");
  const [quantity, setQuantity] = useState("0");
  const [entryOrderType, setEntryOrderType] = useState("MARKET");
  const [price, setPrice] = useState(0);
  const [ifTouchPrice, setIfTouchPrice] = useState(0);
  const [tpType, setTpType] = useState("BY_POINTS");
  const [tpValue, setTpValue] = useState(0);
  const [slType, setSlType] = useState("BY_POINTS");
  const [slValue, setSlValue] = useState(0);
  const [slIfTouchPrice, setSlIfTouchPrice] = useState(0);
  const [breakevenType, setBreakevenType] = useState("BY_POINTS");
  const [breakeven, setBreakeven] = useState(0);
  const [slTrailType, setSlTrailType] = useState("BY_POINTS");
  const [slTrailValue, setSlTrailValue] = useState(0);
  const [slPriceMove, setSlPriceMove] = useState(0);
  const [showExpiry1, setShowExpiry1] = useState("month");
  const [list, setList] = useState({});
  const [listsCache, setListsCache] = useState({});

  // Refs
  const symbolInputRef = useRef(null);
  const quantityInputRef = useRef(null);
  const priceInputRef = useRef(null);
  const tpValueInputRef = useRef(null);
  const slValueInputRef = useRef(null);
  const breakevenInputRef = useRef(null);
  const slTrailValueInputRef = useRef(null);
  const slPriceMoveInputRef = useRef(null);
  const expireInputRef = useRef(null);
  const touchPriceInputRef = useRef(null);

  // Apply dark mode
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  // Listen to exit position / pre-fill events from other panels
  useEffect(() => {
    const handleFillOrder = (event) => {
      const data = event.detail;
      console.log("📥 Pre-filling order form:", data);
      if (data.symbol !== undefined) setSymbol(data.symbol);
      if (data.exchange !== undefined) setExchange(data.exchange);
      if (data.contractType !== undefined) setContractType(data.contractType);
      if (data.monthlyExpiry !== undefined) setMonthlyExpiry(data.monthlyExpiry);
      if (data.weeklyExpiry !== undefined) setWeeklyExpiry(data.weeklyExpiry);
      if (data.exactStrike !== undefined) setExactStrike(data.exactStrike);
      if (data.action !== undefined) setAction(data.action);
      if (data.quantity !== undefined) setQuantity(String(data.quantity));
      if (data.quantityType !== undefined) setQuantityType(data.quantityType);
      if (data.showExpiry1 !== undefined) setShowExpiry1(data.showExpiry1);
    };

    window.addEventListener("fill-order-form", handleFillOrder);
    return () => {
      window.removeEventListener("fill-order-form", handleFillOrder);
    };
  }, []);

  const handleClose = () => setActiveModal(null);
  const handleInputFocus = (e) => e.target.select();

  // Fetch symbols
  const keyMapping = {
    "BSE:Equity": "BSE_EQ", "BSE:Futures": "BSE_FUT", "BSE:Options": "BSE_OPT", "BSE:Call/Put": "BSE_OPT",
    "NSE:Equity": "NSE_EQ", "NSE:Futures": "NSE_FUT", "NSE:Options": "NSE_OPT", "NSE:Call/Put": "NSE_OPT",
  };

  useEffect(() => {
    if (exchange && contractType && token) {
      const rawKey = `${exchange}:${contractType}`;
      const key = keyMapping[rawKey] || rawKey;

      if (listsCache[key]) {
        setList(listsCache[key]);
        return;
      }

      const fetchSymbols = async () => {
        const payload = { exchange, contract_type: contractType };
        const result = await fetchSymbolService(token, payload);
        if (result.success && result.data?.data) {
          const symbols = result.data.data;
          const symbolDict = symbols.reduce((acc, item) => {
            acc[item] = item;
            return acc;
          }, {});
          setListsCache((prev) => ({ ...prev, [key]: symbolDict }));
          setList(symbolDict);
        } else {
          setList({});
        }
      };
      fetchSymbols();
    } else {
      setList({});
    }
  }, [exchange, contractType, token]);

  const handleChange1 = (e) => {
    setSymbol(e.target.value.toUpperCase());
  };

  // API Data
  const data = {
    symbol: symbol,
    exchange: exchange,
    contract_type: contractType,
    monthly_expiry: Number(monthlyExpiry),
    weekly_expiry: Number(weeklyExpiry),
    exact_strike: Number(exactStrike),
    expire_in_second: Number(expireInSecond),
    duplicate_position: duplicatePosition,
    action: action,
    quantity: action === "CLOSE" ? 1 : Number(quantity || 0),
    quantity_type: quantityType === "normal" ? "NORMAL" : quantityType === "by_risk_percentage" ? "BY_RISK_PERCENTAGE" : "BY_AMOUNT",
    entry_order_type: entryOrderType,
    price: Number(price),
    update_order_id: "",
    update_type: "",
    if_touch_price: Number(ifTouchPrice),
    tp_type: tpType?.toUpperCase() || "NORMAL",
    tp_value: Number(tpValue),
    sl_type: slType?.toUpperCase() || "NORMAL",
    sl_value: Number(slValue),
    sl_if_touch_price: Number(slIfTouchPrice),
    breakeven_type: breakevenType?.toUpperCase() || "NORMAL",
    breakeven: Number(breakeven),
    sl_trail_type: slTrailType,
    sl_trail_value: Number(slTrailValue),
    sl_price_move: Number(slPriceMove),
    existing_close: existingClose,
  };

  const generatAlertData = { ...data };
  const strategyJson = {
    ...data,
    action: "{{strategy.order.action}}",
    quantity: "{{strategy.order.contracts}}",
  };

  // Validation
  const validateExecute = () => {
    if (!symbol || symbol.trim() === "") return "❌ Symbol is required!";
    if (action !== "CLOSE" && (!quantity || Number(quantity) <= 0)) return "❌ Quantity must be greater than 0!";
    return null;
  };

  // Get security key
  const getSecurityKey = () => {
    try {
      let key = getSecKey();
      if (key && key !== "undefined" && key !== "null" && key.length > 10) return key;
      key = localStorage.getItem('sec_key');
      if (key && key !== "undefined" && key !== "null" && key.length > 10) return key;
      key = localStorage.getItem('session-token');
      if (key && key.length > 10) return key;
      return null;
    } catch (error) {
      console.error("Error getting security key:", error);
      return null;
    }
  };

  // Execute button
  const handleExecuteButton = async () => {
    const secKey = getSecurityKey();
    const validateError = validateExecute();
    if (validateError) {
      toast.warning(validateError);
      return;
    }
    if (!secKey) {
      toast.error("🔑 Security key not found! Please refresh.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await executeAlertDataService(data, secKey);
      if (response.status === 200) {
        if (response?.data?.error === false) {
          toast.success(response?.data?.data || "Order executed successfully!");
          sendGlobalWS({ r: "orders" });
          sendGlobalWS({ r: "positions" });
          sendGlobalWS({ r: "alerts" });
        } else {
          toast.error(response?.data?.data || "Execution failed");
        }
      } else {
        toast.error(response?.data?.data || "Execution failed");
      }
    } catch (error) {
      console.error("Execute error:", error);
      toast.error(error?.response?.data?.data || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  // Reset
  const handleReset = () => {
    setSymbol("");
    setContractType("EQ");
    setExchange("NSE");
    setMonthlyExpiry(0);
    setWeeklyExpiry(0);
    setExactStrike(0);
    setDuplicatePosition(false);
    setExpireInSecond(0);
    setExistingClose(false);
    setQuantityType("normal");
    setQuantity("0");
    setEntryOrderType("MARKET");
    setPrice(0);
    setIfTouchPrice(0);
    setTpType("BY_POINTS");
    setTpValue(0);
    setSlType("BY_POINTS");
    setSlValue(0);
    setSlIfTouchPrice(0);
    setBreakevenType("BY_POINTS");
    setBreakeven(0);
    setSlTrailType("BY_POINTS");
    setSlTrailValue(0);
    setSlPriceMove(0);
    setShowExpiry1("month");
    setShowRiskSettings(false);
    setShowAdvancedSettings(false);
    toast.info("🔄 Form reset successfully!");
  };

  const handleCopyJSON = () => {
    const jsonString = activeTab === "strategy" 
      ? JSON.stringify(strategyJson, null, 2)
      : JSON.stringify(generatAlertData, null, 2);
    navigator.clipboard.writeText(jsonString);
    toast.success("📋 JSON copied!");
  };

  const handleCopyURL = () => {
    const secKey = getSecurityKey();
    if (secKey) {
      navigator.clipboard.writeText(`https://api.algocontroller.com/v2/sendAlert/${secKey}`);
      toast.success("🔗 Webhook URL copied!");
    } else {
      toast.error("Cannot copy URL: Security key not found!");
    }
  };

  const handleGenerateAlertModel = () => {
    if (!symbol || symbol.trim() === "" || quantity <= 0) {
      toast.warning("⚠️ Please select Symbol and Quantity");
    } else {
      setActiveModal("alert-model");
    }
  };

  const handleRiskSetting = (e) => {
    e.preventDefault();
    setShowRiskSettings(!showRiskSettings);
  };

  const handleAdvanceSetting = (e) => {
    e.preventDefault();
    setShowAdvancedSettings(!showAdvancedSettings);
  };

  // Conditions
  const isFut = contractType === "FUT";
  const isOption = contractType === "CE" || contractType === "PE";
  const showExpiryMonth1 = showExpiry1 === "month" && isFut;
  const showCallPutMonthly = showExpiry1 === "month" && isOption;
  const showCallPutWeekly = showExpiry1 === "week" && isOption;
  const showIfTouchPrice = entryOrderType === "LIMIT";

  // CSS Styles
  const selectStyle = `w-full px-2 py-1.5 rounded-md border text-xs transition-all duration-200
    bg-[var(--input-bg)] text-[var(--input-text)] border-[var(--input-border)]
    outline-none appearance-none`;

  const labelStyle = `block text-[11px] font-medium mb-1 transition-colors duration-200 text-[var(--label-color)]`;
  const sectionStyle = "mt-4 w-full";
  const cardStyle = `rounded-lg p-3 transition-colors duration-200 bg-[var(--card-bg)] border border-[var(--card-border)]`;
  const headingStyle = `text-sm font-semibold transition-colors duration-200 text-[var(--heading-color)]`;
  const buttonStyle = `flex items-center gap-1.5 px-3 py-1.5 rounded-md font-medium transition-all duration-300 shadow-md hover:shadow-lg text-xs
    bg-[var(--button-primary)] hover:bg-[var(--button-primary-hover)] text-white`;
  const resetButtonStyle = `px-4 py-1.5 rounded-md font-medium transition-all duration-200 text-xs
    bg-[var(--button-reset-bg)] hover:bg-[var(--button-reset-hover)] text-[var(--text-primary)] border border-[var(--border-color)]`;
  const infoButtonStyle = `p-1 rounded-md transition-colors duration-200 hover:bg-gray-200 dark:hover:bg-gray-700 text-[var(--text-muted)]`;
  const checkboxLabelStyle = `flex items-center gap-2 text-xs cursor-pointer transition-colors duration-200 text-[var(--text-primary)]`;
  const inputStyle = `w-full px-2 py-1.5 rounded-md border text-xs transition-all duration-200
    bg-[var(--input-bg)] text-[var(--input-text)] border-[var(--input-border)]
    focus:outline-none focus:ring-1 focus:ring-blue-500`;
 
  const optionClass = (darkMode) => darkMode ? "bg-gray-700 text-gray-200 hover:bg-gray-600" : "bg-white text-gray-900 hover:bg-gray-100";

  // Format functions
  const formatAmount = (value) => {
    if (!value || value === 0) return "₹ 0";
    return `₹ ${value}`;
  };

  return (
    <div className={`h-full w-full overflow-y-auto transition-all duration-300 bg-[var(--bg-primary)]`}>
      <div className="p-3">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <button onClick={handleGenerateAlertModel} className={buttonStyle}>
            <span className="text-xs">📈 Generate Trading Webhook</span>
          </button>
          {onClose && (
            <button onClick={onClose} className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700">
              <FiX size={16} className="text-[var(--text-muted)]" />
            </button>
          )}
        </div>

        <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
          
          {/* ========== CONTRACT DETAILS ========== */}
          <div className={sectionStyle}>
            <div className="flex items-center justify-between mb-2">
              <h3 className={headingStyle}>📋 Contract Details</h3>
              <button onClick={() => setActiveModal("modal1")} className={infoButtonStyle} type="button">
                <FaRegFileAlt className="text-[10px]" />
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              <div>
                <label className={labelStyle}>Exchange</label>
                <select className={selectStyle} value={exchange} onChange={(e) => { setExchange(e.target.value); setSymbol(""); }}>
                  <option value="NSE" className={optionClass(darkMode)}>NSE</option>
                  <option value="BSE" className={optionClass(darkMode)}>BSE</option>
                </select>
              </div>

              <div>
                <label className={labelStyle}>Contract Type</label>
                <select className={selectStyle} value={contractType} onChange={(e) => { setContractType(e.target.value); setSymbol(""); }}>
                  <option value="EQ" className={optionClass(darkMode)}>Equity</option>
                  <option value="FUT" className={optionClass(darkMode)}>Future</option>
                  <option value="CE" className={optionClass(darkMode)}>Call</option>
                  <option value="PE" className={optionClass(darkMode)}>Put</option>
                </select>
              </div>

              {/* ✅ FIXED: Symbol input - No syntax error */}
              <div>
                <label className={labelStyle}>Symbol</label>
                <input ref={symbolInputRef} list="symbols" type="text" placeholder="Search symbol..." className={inputStyle} value={symbol} onChange={handleChange1} onFocus={handleInputFocus} />
                <datalist id="symbols">
                  {Object.entries(list || {}).map(([key, value], index) => (
                    <option key={index} value={key} className={optionClass(darkMode)}>
                      {key}
                    </option>
                  ))}
                </datalist>
              </div>
            </div>

            {/* Expiry Section */}
            {(isFut || isOption) && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3">
                <div>
                  <label className={labelStyle}>Select Expiry</label>
                  <select className={selectStyle} value={showExpiry1} onChange={(e) => setShowExpiry1(e.target.value)}>
                    {isFut ? (
                      <option value="month" className={optionClass(darkMode)}>Monthly</option>
                    ) : (
                      <>
                        <option value="month" className={optionClass(darkMode)}>Monthly</option>
                        <option value="week" className={optionClass(darkMode)}>Weekly</option>
                      </>
                    )}
                  </select>
                </div>

                {(showExpiryMonth1 || showCallPutMonthly) && (
                  <div>
                    <label className={labelStyle}>Monthly Expiry</label>
                    <select className={selectStyle} value={monthlyExpiry} onChange={(e) => { const val = Number(e.target.value); setMonthlyExpiry(val); if (val !== 0) setWeeklyExpiry(0); }}>
                      <option value={0} className={optionClass(darkMode)}>Select</option>
                      <option value={1} className={optionClass(darkMode)}>1</option>
                      <option value={2} className={optionClass(darkMode)}>2</option>
                      <option value={3} className={optionClass(darkMode)}>3</option>
                    </select>
                  </div>
                )}

                {showCallPutWeekly && (
                  <div>
                    <label className={labelStyle}>Weekly Expiry</label>
                    <select className={selectStyle} value={weeklyExpiry} onChange={(e) => { const val = Number(e.target.value); setWeeklyExpiry(val); if (val !== 0) setMonthlyExpiry(0); }}>
                      <option value={0} className={optionClass(darkMode)}>Select</option>
                      <option value={1} className={optionClass(darkMode)}>1</option>
                      <option value={2} className={optionClass(darkMode)}>2</option>
                      <option value={3} className={optionClass(darkMode)}>3</option>
                    </select>
                  </div>
                )}

                {(contractType === "CE" || contractType === "PE") && (
                  <div>
                    <label className={labelStyle}>Exact Strike</label>
                    <input type="number" min="0" value={exactStrike} onChange={(e) => setExactStrike(parseFloat(e.target.value))} onFocus={handleInputFocus} className={inputStyle} />
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ========== ORDER SETTINGS ========== */}
          <div className={sectionStyle}>
            <div className="flex items-center justify-between mb-2">
              <h3 className={headingStyle}>⚙️ Order Settings</h3>
              <button onClick={() => setActiveModal("modal2")} className={infoButtonStyle} type="button">
                <FaRegFileAlt className="text-[10px]" />
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              <div>
                <label className={labelStyle}>Entry Order Type</label>
                <select value={entryOrderType} onChange={(e) => setEntryOrderType(e.target.value)} className={selectStyle}>
                  <option value="MARKET" className={optionClass(darkMode)}>Market</option>
                  <option value="LIMIT" className={optionClass(darkMode)}>Limit</option>
                </select>
              </div>

              <div>
                <label className={labelStyle}>Action</label>
                <select value={action} onChange={(e) => setAction(e.target.value)} className={selectStyle}>
                  <option value="BUY" className={optionClass(darkMode)}>Buy</option>
                  <option value="SELL" className={optionClass(darkMode)}>Sell</option>
                  <option value="CLOSE" className={optionClass(darkMode)}>Close</option>
                </select>
              </div>

              <div>
                <label className={labelStyle}>Expire (Sec)</label>
                <input ref={expireInputRef} type="number" min="0" value={expireInSecond} onChange={(e) => setExpireInSecond(Number(e.target.value))} onFocus={handleInputFocus} className={inputStyle} />
              </div>

              <div>
                <label className={labelStyle}>Touch Price</label>
                <input ref={touchPriceInputRef} type="text" value={formatAmount(ifTouchPrice)} onChange={(e) => {
                  let val = e.target.value.replace(/[^\d.]/g, "");
                  setIfTouchPrice(val === "" ? 0 : Number(val));
                }} onFocus={handleInputFocus} className={inputStyle} />
              </div>

              <div>
                <label className={labelStyle}>Quantity Type</label>
                <select value={quantityType} onChange={(e) => { setQuantityType(e.target.value); setQuantity("0"); }} className={selectStyle}>
                  <option value="normal" className={optionClass(darkMode)}>Normal</option>
                  <option value="by_risk_percentage" className={optionClass(darkMode)}>By Risk %</option>
                  <option value="by_amount" className={optionClass(darkMode)}>By Amount</option>
                </select>
              </div>

              <div>
                <label className={labelStyle}>
                  {quantityType === "normal" ? "Quantity" : quantityType === "by_risk_percentage" ? "Risk %" : "Amount"}
                </label>
                <input ref={quantityInputRef} type="text" value={
                  quantityType === "by_risk_percentage" ? (quantity ? `${quantity} %` : "0 %") :
                  quantityType === "by_amount" ? (quantity ? `₹ ${quantity}` : "₹ 0") : quantity
                } onChange={(e) => {
                  let val = e.target.value;
                  if (quantityType === "by_risk_percentage") {
                    val = val.replace(/[^\d.]/g, "");
                    setQuantity(val === "" ? "0" : val);
                  } else if (quantityType === "by_amount") {
                    val = val.replace(/[^\d.]/g, "");
                    setQuantity(val === "" ? "0" : val);
                  } else {
                    setQuantity(e.target.value);
                  }
                }} onFocus={handleInputFocus} className={inputStyle} />
              </div>

              {showIfTouchPrice && (
                <div>
                  <label className={labelStyle}>Price</label>
                  <input ref={priceInputRef} type="text" value={formatAmount(price)} onChange={(e) => {
                    let val = e.target.value.replace(/[^\d.]/g, "");
                    setPrice(val === "" ? 0 : Number(val));
                  }} onFocus={handleInputFocus} className={inputStyle} />
                </div>
              )}
            </div>
          </div>

          {/* ========== RISK SETTINGS ========== */}
          {action !== "CLOSE" && (
            <>
              <div className={sectionStyle}>
                <button onClick={handleRiskSetting} type="button" className="flex items-center gap-1.5 text-xs font-semibold mb-2 text-[var(--heading-color)] hover:opacity-80">
                  🛡️ Risk Settings {showRiskSettings ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                </button>

                {showRiskSettings && (
                  <div className={cardStyle}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                      <div>
                        <label className={labelStyle}>TP Type</label>
                        <select value={tpType} onChange={(e) => setTpType(e.target.value)} className={selectStyle}>
                          <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
                          <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
                          <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
                        </select>
                      </div>
                      <div>
                        <label className={labelStyle}>{tpType === "BY_POINTS" ? "TP Point" : tpType === "BY_PERCENT" ? "TP %" : "TP Value"}</label>
                        <input ref={tpValueInputRef} type="text" value={tpValue} onChange={(e) => {
                          let val = e.target.value.replace(/[^\d.]/g, "");
                          setTpValue(val === "" ? 0 : Number(val));
                        }} onFocus={handleInputFocus} className={inputStyle} />
                      </div>
                      <div>
                        <label className={labelStyle}>SL Type</label>
                        <select value={slType} onChange={(e) => setSlType(e.target.value)} className={selectStyle}>
                          <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
                          <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
                          <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
                        </select>
                      </div>
                      <div>
                        <label className={labelStyle}>{slType === "BY_POINTS" ? "SL Point" : slType === "BY_PERCENT" ? "SL %" : "SL Value"}</label>
                        <input ref={slValueInputRef} type="text" value={slValue} onChange={(e) => {
                          let val = e.target.value.replace(/[^\d.]/g, "");
                          setSlValue(val === "" ? 0 : Number(val));
                        }} onFocus={handleInputFocus} className={inputStyle} />
                      </div>
                      <div>
                        <label className={labelStyle}>SL Touch Price</label>
                        <input type="text" value={formatAmount(slIfTouchPrice)} onChange={(e) => {
                          let val = e.target.value.replace(/[^\d.]/g, "");
                          setSlIfTouchPrice(val === "" ? 0 : Number(val));
                        }} onFocus={handleInputFocus} className={inputStyle} />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* ========== ADVANCED SETTINGS ========== */}
              <div className={sectionStyle}>
                <button onClick={handleAdvanceSetting} type="button" className="flex items-center gap-1.5 text-xs font-semibold mb-2 text-[var(--heading-color)] hover:opacity-80">
                  🔧 Advanced Settings {showAdvancedSettings ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                </button>

                {showAdvancedSettings && (
                  <div className={cardStyle}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                      <div>
                        <label className={labelStyle}>Breakeven Type</label>
                        <select value={breakevenType} onChange={(e) => setBreakevenType(e.target.value)} className={selectStyle}>
                          <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
                          <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
                          <option value="NORMAL" className={optionClass(darkMode)}>Normal</option>
                        </select>
                      </div>
                      <div>
                        <label className={labelStyle}>{breakevenType === "BY_POINTS" ? "Point" : breakevenType === "BY_PERCENT" ? "%" : "Value"}</label>
                        <input ref={breakevenInputRef} type="text" value={breakeven} onChange={(e) => {
                          let val = e.target.value.replace(/[^\d.]/g, "");
                          setBreakeven(val === "" ? 0 : Number(val));
                        }} onFocus={handleInputFocus} className={inputStyle} />
                      </div>
                      <div>
                        <label className={labelStyle}>SL Trail Type</label>
                        <select value={slTrailType} onChange={(e) => setSlTrailType(e.target.value)} className={selectStyle}>
                          <option value="BY_POINTS" className={optionClass(darkMode)}>By Points</option>
                          <option value="BY_PERCENT" className={optionClass(darkMode)}>By Percent</option>
                        </select>
                      </div>
                      <div>
                        <label className={labelStyle}>{slTrailType === "BY_POINTS" ? "Trail Point" : "Trail %"}</label>
                        <input ref={slTrailValueInputRef} type="text" value={slTrailValue} onChange={(e) => {
                          let val = e.target.value.replace(/[^\d.]/g, "");
                          setSlTrailValue(val === "" ? 0 : Number(val));
                        }} onFocus={handleInputFocus} className={inputStyle} />
                      </div>
                      <div>
                        <label className={labelStyle}>SL Price Move</label>
                        <input ref={slPriceMoveInputRef} type="text" value={formatAmount(slPriceMove)} onChange={(e) => {
                          let val = e.target.value.replace(/[^\d.]/g, "");
                          setSlPriceMove(val === "" ? 0 : Number(val));
                        }} onFocus={handleInputFocus} className={inputStyle} />
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-3 mt-3">
                      <label className={checkboxLabelStyle}>
                        <input type="checkbox" checked={duplicatePosition} onChange={(e) => setDuplicatePosition(e.target.checked)} />
                        Duplicate Position
                      </label>
                      <label className={checkboxLabelStyle}>
                        <input type="checkbox" checked={existingClose} onChange={(e) => setExistingClose(e.target.checked)} />
                        Existing Close
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {/* ========== FOOTER ========== */}
          <div className="sticky bottom-0 py-2 mt-4 border-t bg-[var(--bg-footer)] border-[var(--border-color)]">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
              <div className="text-[11px] text-[var(--text-muted)]">
                {action} • {entryOrderType} • {symbol || "No symbol"}
              </div>
              <div className="flex gap-2">
                <button onClick={handleExecuteButton} disabled={isLoading} className={`${buttonStyle} ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`} type="button">
                  {isLoading ? <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : "Execute"}
                </button>
                <button onClick={handleReset} type="button" className={resetButtonStyle}>Reset</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* Modals */}
      <Modal show={activeModal === "alert-model"} onHide={handleClose} centered size="lg">
        <Modal.Body className="p-0">
          <div className="flex justify-between gap-2 px-3 py-2 border-b bg-gray-100 dark:bg-gray-800 rounded-t-md">
            <button onClick={handleCopyJSON} className="bg-blue-500 text-white px-3 py-1 rounded-md text-xs" type="button">📋 Copy JSON</button>
            <button onClick={handleCopyURL} className="bg-green-500 text-white px-3 py-1 rounded-md text-xs" type="button">🔗 Copy Webhook URL</button>
          </div>
          <div className="p-3">
            <div className="flex gap-2 mb-3">
              {["normal", "indicator", "strategy"].map((tab) => (
                <button key={tab} onClick={() => setActiveTab(tab)} className={`px-3 py-1.5 rounded-md text-xs ${activeTab === tab ? 'bg-blue-500 text-white' : 'bg-gray-200 dark:bg-gray-700'}`} type="button">
                  {tab.toUpperCase()}
                </button>
              ))}
            </div>
            <pre className="p-3 rounded-md overflow-auto max-h-[350px] text-xs bg-gray-900 text-green-400">
              {activeTab === "strategy" ? JSON.stringify(strategyJson, null, 2) : JSON.stringify(generatAlertData, null, 2)}
            </pre>
          </div>
          <div className="flex justify-end px-3 py-2 border-t bg-gray-100 dark:bg-gray-800 rounded-b-md">
            <Button variant="secondary" onClick={handleClose} className="px-3 py-1 text-xs">Close</Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Info Modals */}
      {["modal1", "modal2", "modal3", "modal4"].map((modalId) => (
        <Modal key={modalId} show={activeModal === modalId} onHide={handleClose} centered>
          <Modal.Header closeButton className="py-2 bg-gray-100 dark:bg-gray-800">
            <Modal.Title className="text-sm">
              {modalId === "modal1" && "📋 Contract Overview"}
              {modalId === "modal2" && "⚙️ Order Settings Overview"}
              {modalId === "modal3" && "🛡️ Risk Settings Overview"}
              {modalId === "modal4" && "🔧 Advanced Settings Overview"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3">
            <div className="space-y-2 text-xs">
              {modalId === "modal1" && (<><p><strong>Exchange:</strong> NSE and BSE supported</p><p><strong>Contract Type:</strong> Equity, Future, Call, Put</p></>)}
              {modalId === "modal2" && (<><p><strong>Order Type:</strong> Market and Limit orders</p><p><strong>Action:</strong> Buy, Sell, or Close</p></>)}
              {modalId === "modal3" && (<><p><strong>TP/SL Types:</strong> Normal, Points, or Percentage based</p></>)}
              {modalId === "modal4" && (<><p><strong>Breakeven:</strong> Shifts SL to entry price</p><p><strong>Trailing SL:</strong> Auto adjusts SL</p></>)}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-2 bg-gray-100 dark:bg-gray-800">
            <Button size="sm" variant="secondary" onClick={handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      ))}
    </div>
  );
};

export default AlertWindow;